import { dismissAlert } from '@calendly/alert'

import changeSet from 'core/change_set'
import { resetSULAnalytics } from 'features/single_use_link_analytics'

export const initializeSingleUseLinkSidebar = () => async (dispatch) => {
  changeSet.allowDirtyNavigation()
}

export const resetSingleUseLinkSidebar = ({ resetAnalytics = true, resetAlert = false }) => async (dispatch) => {
  if (resetAnalytics) { dispatch(resetSULAnalytics()) }
  if (resetAlert) { dispatch(dismissAlert()) }
  changeSet.reset()
}
